import {apps} from "../index";
import type {AdjustPayload} from "./adjustPayload";
import type {ExtendedPromise, OttoNexus} from "@otto-ec/global-resources/nexus";

export type ThirdpartyTrackingRaw = {
    /**
 *
 */
    trackAdjust(adjustPayload: AdjustPayload): ExtendedPromise;
}

export type ThirdpartyTracking = OttoNexus["apps"]["thirdpartyTracking"]

/**
 *
 */
export const thirdpartyTracking: ThirdpartyTracking = apps.thirdpartyTracking;

/**
 *
 */
export const trackAdjust: ThirdpartyTracking["trackAdjust"] = thirdpartyTracking.trackAdjust;


